module.exports = __webpack_public_path__ + "img/tintuc11.7fe8633c.png";